import { useEffect } from 'react'

import { Button } from 'core-components/library/button'
import { Input } from 'core-components/library/inputs'
import { IStaticProps, TStaticPropsType } from 'core-components/sitebuilder/models/IWidget'

import { EMPTY_OBJECT_DATA } from './constants/objectData'
import { BASE_STATIC_PROPS_TYPE_DATA } from './constants/staticPropsType'
import { TypeSelector } from './TypeSelector'
import { ValueEditor } from './ValueEditor'

import styles from './ObjectEditor.module.scss'

interface IObjectEditor {
  value: IStaticProps[]
  editorType: 'object' | 'array'
  onChange: (newValue: IStaticProps[]) => void
}

export const ObjectEditor = ({ value, onChange, editorType }: IObjectEditor) => {
  useEffect(() => {
    if (!value.length) {
      onChange([EMPTY_OBJECT_DATA])
    }
  }, [value])

  return (
    <div className={styles.root}>
      {value.map((objectData, index) => {
        return (
          <div key={index} className={styles.property}>
            {editorType === 'object' ? (
              <Input
                label={'key'}
                value={objectData.paramName}
                onChange={(newKey) => {
                  value[index] = { ...value[index], paramName: newKey }
                  onChange([...value])
                }}
              />
            ) : null}

            <ValueEditor
              staticElement={objectData}
              isRequired={false}
              onChange={(newValue) => {
                value[index] = { ...value[index], paramValue: newValue }
                onChange([...value])
              }}
            />

            <TypeSelector
              disabled={false}
              value={objectData.paramType}
              items={BASE_STATIC_PROPS_TYPE_DATA}
              onChange={(newValue) => {
                value[index] = { ...value[index], paramType: newValue as TStaticPropsType }
                onChange([...value])
              }}
            />

            <Button
              iconButton={'kbase kbase-minus'}
              color={'danger'}
              disabled={value.length < 2}
              onClick={() => {
                const newItems = [...value]
                newItems.splice(index, 1)
                onChange(newItems)
              }}
            />
          </div>
        )
      })}
      <Button onClick={() => onChange([...value, EMPTY_OBJECT_DATA])}>Add key</Button>
    </div>
  )
}
